import { isStateTreeNode } from '@jbrowse/mobx-state-tree';
export * from "./util.js";
export function isViewContainer(thing) {
    return (isStateTreeNode(thing) &&
        'removeView' in thing &&
        'addView' in thing &&
        'views' in thing);
}
export function isSessionModel(thing) {
    return (typeof thing === 'object' &&
        thing !== null &&
        'rpcManager' in thing &&
        'configuration' in thing);
}
export function isSessionModelWithConfigEditing(t) {
    return isSessionModel(t) && 'editConfiguration' in t;
}
export function isSessionWithAddTracks(t) {
    return (isSessionModel(t) && 'addTrackConf' in t && !t.disableAddTracks);
}
export function isSessionWithShareURL(thing) {
    return isSessionModel(thing) && 'shareURL' in thing && !!thing.shareURL;
}
export function isSessionModelWithWidgets(thing) {
    return isSessionModel(thing) && 'widgets' in thing;
}
export function isSessionModelWithConnections(thing) {
    return isSessionModel(thing) && 'makeConnection' in thing;
}
export function isSessionModelWithConnectionEditing(thing) {
    return isSessionModel(thing) && 'addConnectionConf' in thing;
}
export function isSessionWithSessionPlugins(thing) {
    return isSessionModel(thing) && 'sessionPlugins' in thing;
}
export function isSelectionContainer(thing) {
    return (typeof thing === 'object' &&
        thing !== null &&
        'selection' in thing &&
        'setSelection' in thing);
}
export function isViewModel(thing) {
    return (typeof thing === 'object' &&
        thing !== null &&
        'width' in thing &&
        'setWidth' in thing);
}
export function isTrackModel(thing) {
    return (typeof thing === 'object' &&
        thing !== null &&
        'configuration' in thing &&
        thing.configuration.trackId);
}
export function isDisplayModel(thing) {
    return (typeof thing === 'object' &&
        thing !== null &&
        'configuration' in thing &&
        thing.configuration.displayId);
}
export function isTrackViewModel(thing) {
    return (typeof thing === 'object' &&
        thing !== null &&
        'showTrack' in thing &&
        'hideTrack' in thing);
}
export function isAppRootModel(thing) {
    return (typeof thing === 'object' &&
        thing !== null &&
        'findAppropriateInternetAccount' in thing);
}
export function isRootModelWithInternetAccounts(thing) {
    return (typeof thing === 'object' &&
        thing !== null &&
        'internetAccounts' in thing &&
        'findAppropriateInternetAccount' in thing);
}
export function isAbstractMenuManager(thing) {
    return (typeof thing === 'object' &&
        thing !== null &&
        'appendMenu' in thing &&
        'appendToSubMenu' in thing);
}
export function isUriLocation(location) {
    return (typeof location === 'object' &&
        location !== null &&
        'uri' in location &&
        !!location.uri);
}
export function isLocalPathLocation(location) {
    return (typeof location === 'object' &&
        location !== null &&
        'localPath' in location &&
        !!location.localPath);
}
export function isBlobLocation(location) {
    return (typeof location === 'object' &&
        location !== null &&
        'blobId' in location &&
        !!location.blobId);
}
export function isFileHandleLocation(location) {
    return (typeof location === 'object' &&
        location !== null &&
        'handleId' in location &&
        !!location.handleId);
}
export class AuthNeededError extends Error {
    message;
    url;
    constructor(message, url) {
        super(message);
        this.message = message;
        this.url = url;
        this.name = 'AuthNeededError';
        Object.setPrototypeOf(this, AuthNeededError.prototype);
    }
}
export class RetryError extends Error {
    message;
    internetAccountId;
    constructor(message, internetAccountId) {
        super(message);
        this.message = message;
        this.internetAccountId = internetAccountId;
        this.name = 'RetryError';
    }
}
export function isAuthNeededException(exception) {
    return (exception instanceof Error &&
        (exception.name === 'AuthNeededError' ||
            exception.url !== undefined));
}
export function isRetryException(exception) {
    return (exception.name === 'RetryError' ||
        exception.internetAccountId !== undefined);
}
export { default as TextSearchManager } from "../../TextSearch/TextSearchManager.js";
